const PayFortForm = ({
  payFortDetails
}) => <>
    <input type="hidden" name="signature" value={payFortDetails?.signature || ""} />
    <input type="hidden" name="command" value={payFortDetails?.command} />
    <input type="hidden" name="merchant_reference" value={payFortDetails?.merchant_reference || ""} />
    <input type="hidden" name="amount" value={payFortDetails?.amount || ""} />
    <input type="hidden" name="access_code" value={payFortDetails?.access_code || ""} />
    <input type="hidden" name="merchant_identifier" value={payFortDetails?.merchant_identifier || ""} />
    <input type="hidden" name="currency" value={payFortDetails?.currency} />
    <input type="hidden" name="language" value={payFortDetails?.language} />
    <input type="hidden" name="customer_email" value={payFortDetails?.customer_email || ""} />
    <input type="hidden" name="return_url" value={payFortDetails?.return_url || ""} />
  </>;
export default PayFortForm;